import React from "react";
import Skeleton from "../shared/skeleton-component";

const EligibityFormSkeleton = () => {
  return (
    <div className="eligibility-form-container">
      <Skeleton width="355px" height="40px" mobWidth="70vw" />
      <Skeleton width="555px" height="55px" mobWidth="80vw" />
      <div className="selection-card-container">
        {new Array(4).fill("").map((_, index) => {
          return <Skeleton height={"60px"} width={"150px"} key={index} />;
        })}
      </div>
      <div className="field-section">
        <Skeleton width="360px" height="70px" mobWidth="80vw" />
        <Skeleton width="360px" height="70px" mobWidth="80vw" />
        <Skeleton width="360px" height="70px" mobWidth="80vw" />
        <Skeleton width="360px" height="70px" mobWidth="80vw" />
      </div>
      <Skeleton height="60px" width="200px" />
    </div>
  );
};

export default EligibityFormSkeleton;
